/* Fasola favorieten – concepttheme only. Browser-only demo. Not account-synced. */
(() => {
  "use strict";
  const KEY = "fasola-preview-favorieten-v1";
  const lang = (document.documentElement.lang || "nl").slice(0,2);
  const words = {
    nl: { save:"Bewaar als favoriet",remove:"Verwijder uit favorieten",title:"Mijn favorieten",empty:"Je hebt nog geen artikelen bewaard.",notice:"Dit is een testversie. Favorieten worden alleen in deze browser bewaard en zijn nog niet aan je klantaccount gekoppeld.",close:"Sluiten",view:"Bekijk artikel",count:"Opgeslagen artikelen",clear:"Alles verwijderen",preview:"Testversie"},
    de: { save:"Als Favorit speichern",remove:"Aus Favoriten entfernen",title:"Meine Favoriten",empty:"Du hast noch keine Artikel gespeichert.",notice:"Dies ist eine Testversion. Favoriten werden nur in diesem Browser gespeichert und sind noch nicht mit deinem Kundenkonto verbunden.",close:"Schließen",view:"Artikel ansehen",count:"Gespeicherte Artikel",clear:"Alle entfernen",preview:"Testversion"},
    en: { save:"Save to favorites",remove:"Remove from favorites",title:"My favorites",empty:"You haven't saved any items yet.",notice:"This is a test version. Favorites are saved in this browser only and are not connected to your customer account yet.",close:"Close",view:"View product",count:"Saved products",clear:"Remove all",preview:"Test version"}
  };
  const t = words[lang] || words.nl;
  const heart = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M20.8 8.5c0 4.2-5.3 7.6-8.8 10.6C8.5 16.1 3.2 12.7 3.2 8.5a4.9 4.9 0 0 1 8.8-2.7 4.9 4.9 0 0 1 8.8 2.7Z" fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  let saved = [];
  let storeWorks = true;
  try {
    const list = JSON.parse(window.localStorage.getItem(KEY) || "[]");
    if (Array.isArray(list)) saved = list.filter(v => v && typeof v.handle === "string" && /^[a-z0-9-]+$/i.test(v.handle)).slice(-100);
  } catch (_) { storeWorks = false; }
  const routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  const localRoot = typeof routesRoot === "string" && routesRoot.startsWith("/") ? routesRoot.replace(/\/?$/, "/") : (lang === "de" || lang === "en" ? "/" + lang + "/" : "/");
  const hrefFor = handle => localRoot + "products/" + encodeURIComponent(handle);
  const safeHandle = href => {
    try {
      const p = new URL(href, window.location.origin);
      if (p.origin !== window.location.origin) return null;
      const match = p.pathname.match(/\/products\/([a-z0-9-]+)(?:\/|$)/i);
      return match ? match[1].toLowerCase() : null;
    } catch (_) { return null; }
  };
  const validImage = src => {
    try {const u = new URL(src, window.location.href);return (u.protocol === "https:" && (u.hostname.endsWith(".shopify.com") || u.hostname.endsWith(".shopifycdn.net") || u.hostname.endsWith(".myshopify.com") || u.hostname === "fasola.nl")) ? u.href : ""; }
    catch (_) { return ""; }
  };
  const has = handle => saved.some(x => x.handle === handle);
  function persist() { try {localStorage.setItem(KEY, JSON.stringify(saved));storeWorks = true;} catch (_) {storeWorks = false;} }
  let dialog, listEl, counter, headCount;
  const taggedButtons = () => document.querySelectorAll(".fasola-fave-btn[data-fasola-fave-handle]");
  function refresh() {
    taggedButtons().forEach(button => {
      const value = has(button.dataset.fasolaFaveHandle);
      button.classList.toggle("is-saved", value);
      button.setAttribute("aria-pressed", String(value));
      button.setAttribute("aria-label", value ? t.remove : t.save);
      button.title = value ? t.remove : t.save;
    });
    if (headCount) {headCount.textContent = String(saved.length);headCount.hidden = saved.length === 0;}
    if (counter) counter.textContent = String(saved.length);
    if (dialog) renderItems();
  }
  function toggle(details) {
    const idx = saved.findIndex(x => x.handle === details.handle);
    if (idx >= 0) saved.splice(idx,1);
    else saved.unshift(details);
    if (saved.length > 100) saved = saved.slice(0,100);
    persist();refresh();
  }
  function infoFrom(card, productPage) {
    const link = !productPage ? card.querySelector("a.product-image") : null;
    const handle = safeHandle(productPage ? window.location.href : link && link.href);
    if (!handle) return null;
    const title = card.querySelector(".product-info h3, h1[data-fasola-name], .product-info h3, h1")?.textContent?.trim() || handle;
    const image = card.querySelector(".product-image img, .fasola-product-photo img")?.getAttribute("src") || "";
    const price = card.querySelector(".card-bottom .price, .fasola-price")?.textContent?.trim() || "";
    return {handle,name:title.slice(0,160),image:validImage(image),price:price.slice(0,80)};
  }
  function decorate(root, isProduct) {
    if (!root || root.dataset.fasolaFaveDecorated === "1") return;
    const info = infoFrom(root, isProduct);
    if (!info) return;
    const target = isProduct ? root.querySelector(".fasola-product-photo") : root;
    if (!target) return;
    root.dataset.fasolaFaveDecorated = "1";
    target.classList.add("fasola-fave-anchor");
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "fasola-fave-btn";
    btn.dataset.fasolaFaveHandle = info.handle;
    btn.innerHTML = heart;
    btn.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      toggle(info);
    });
    target.appendChild(btn);
  }
  function renderItems() {
    if (!listEl) return;
    listEl.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement("p"); empty.className = "fasola-fave-empty";empty.textContent = t.empty;listEl.appendChild(empty);return;
    }
    for (const item of saved) {
      const li = document.createElement("li");li.className = "fasola-fave-row";
      const link = document.createElement("a");link.href=hrefFor(item.handle);link.className="fasola-fave-product-link";
      if(item.image) {const img=document.createElement("img");img.src=item.image;img.alt="";img.loading="lazy";link.appendChild(img);}
      const txt=document.createElement("span");txt.className="fasola-fave-product-text";
      const name=document.createElement("span");name.className="fasola-fave-product-name";name.textContent=item.name;
      txt.appendChild(name);
      if(item.price){const price=document.createElement("small");price.textContent=item.price;txt.appendChild(price);}
      link.appendChild(txt);li.appendChild(link);
      const remove=document.createElement("button");remove.type="button";remove.className="fasola-fave-remove";remove.setAttribute("aria-label",t.remove);remove.title=t.remove;remove.textContent="×";
      remove.addEventListener("click",()=>{saved=saved.filter(x=>x.handle!==item.handle);persist();refresh();});
      li.appendChild(remove);listEl.appendChild(li);
    }
  }
  function makeDialog() {
    if (dialog) return;
    dialog = document.createElement("dialog");
    dialog.className = "fasola-faves-dialog";
    dialog.setAttribute("aria-label",t.title);
    const panel=document.createElement("div");panel.className="fasola-faves-panel";
    const top=document.createElement("div");top.className="fasola-faves-top";
    const title=document.createElement("h2");title.textContent=t.title;
    const close=document.createElement("button");close.type="button";close.className="fasola-faves-close";close.textContent="×";close.setAttribute("aria-label",t.close);
    close.addEventListener("click",()=>dialog.close());
    top.append(title,close);panel.appendChild(top);
    const note=document.createElement("p");note.className="fasola-fave-disclaimer";note.textContent=t.notice;panel.appendChild(note);
    const countline=document.createElement("p");countline.className="fasola-fave-countline";
    countline.append(document.createTextNode(t.count + ": "));counter=document.createElement("strong");countline.appendChild(counter);panel.appendChild(countline);
    listEl=document.createElement("ul");listEl.className="fasola-faves-list";panel.appendChild(listEl);
    const foot=document.createElement("div");foot.className="fasola-faves-footer";
    const clear=document.createElement("button");clear.type="button";clear.className="fasola-faves-clear";clear.textContent=t.clear;
    clear.addEventListener("click",()=>{saved=[];persist();refresh();});
    foot.appendChild(clear);panel.appendChild(foot);dialog.appendChild(panel);
    dialog.addEventListener("click",e=>{if(e.target===dialog)dialog.close();});
    document.body.appendChild(dialog);
  }
  function openDialog() {
    makeDialog();refresh();
    if(typeof dialog.showModal === "function" && !dialog.open) dialog.showModal();
    else dialog.setAttribute("open","");
  }
  function makeHeader() {
    const actions=document.querySelector(".header-actions");
    if (!actions || actions.querySelector(".fasola-faves-launch"))return;
    const button=document.createElement("button");button.type="button";button.className="fasola-faves-launch";button.setAttribute("aria-label",t.title);
    button.setAttribute("title",t.title);
    button.innerHTML=heart;
    headCount=document.createElement("span");headCount.className="fasola-faves-badge";headCount.hidden=true;button.appendChild(headCount);
    button.addEventListener("click",openDialog);
    const bag=actions.querySelector(".bag-button");
    if(bag)actions.insertBefore(button,bag);else actions.appendChild(button);
  }
  let busy=false;
  function mount() {
    if(busy)return;busy=true;
    requestAnimationFrame(()=>{
      busy=false;
      makeHeader();
      document.querySelectorAll("article.product-card").forEach(card=>decorate(card,false));
      const single=document.querySelector(".fasola-native-product[data-fasola-product]");
      if(single)decorate(single,true);
      refresh();
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init,{once:true});
  else init();
  function init(){
    makeHeader();mount();
    const ob = new MutationObserver(mutations => {
      if(mutations.some(m=>Array.from(m.addedNodes).some(n=>n.nodeType===1&&(n.matches?.(".product-card,.fasola-native-product,.header-actions")||n.querySelector?.(".product-card,.fasola-native-product,.header-actions")))))mount();
    });
    ob.observe(document.body,{childList:true,subtree:true});
    document.addEventListener("shopify:section:load",mount);
  }
})();